<template>
  <div class="reference-card px-4 py-3">
    <div class="vertical-group">
      <div class="title">
        <span
          v-if="reference.studyNumber"
          class="study-id grey--text text--lighten-1"
          data-testid="study-id"
        >
          {{ reference.displayStudyId }}
        </span>
        <highlightable-content :highlight-terms="highlightTerms">
          {{ reference.publication.title }}
        </highlightable-content>
      </div>
      <div class="publication-metadata horizontal-group">
        <div class="author-and-year">
          {{ reference.publication.firstAuthor() }}
          {{ reference.publication.year }}
        </div>
        <div class="place-published">
          {{ reference.publication.placePublished }}
        </div>
      </div>
      <div class="stage-chips horizontal-group">
        <review-stage-chip :stage="reviewStage" />
        <review-stage-status-badge
          :stage="reviewStage"
          :status="reviewStageStatus"
        />
      </div>
    </div>
    <div class="reference-metadata">
      <div class="horizontal-group">
        <missing-abstract-chip
          v-if="missingAbstract"
          @click="$emit('add-abstract')"
        />
        <icon-badge
          v-if="reference.hasFullTextPdf()"
          icon="picture_as_pdf"
          label="PDF"
        />
        <icon-badge
          v-if="reference.tags.length > 0"
          icon="local_offer"
          :label="reference.tags.length"
        />
        <icon-badge
          v-if="reference.comments.length > 0"
          icon="mode_comment"
          :label="reference.comments.length"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconBadge from '@/components/Common/IconBadge';
import HighlightableContent from '@/components/Common/HighlightableContent';
import MissingAbstractChip from '@/components/References/MissingAbstractChip';
import ReviewStageChip from './ReviewStageChip';
import ReviewStageStatusBadge from './ReviewStageStatusBadge';
import { Reference } from '@/models';

export default {
  name: 'ReferenceCardCollapsed',
  components: {
    IconBadge,
    HighlightableContent,
    MissingAbstractChip,
    ReviewStageChip,
    ReviewStageStatusBadge,
  },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    highlightTerms: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['add-abstract'],
  computed: {
    reviewStage() {
      return this.reference.getReviewStage();
    },
    reviewStageStatus() {
      return this.reference.getReviewStageStatus();
    },
    missingAbstract() {
      return !this.reference.publication.abstract?.trim();
    },
  },
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.reference-card {
  display: flex;
  justify-content: space-between;
  gap: 12px;

  cursor: pointer;

  .title {
    font-size: 16px !important;
    font-weight: 400;
    line-height: 19.2px;

    .study-id {
      font-weight: 400;
      margin-right: 6px;
    }
  }

  .vertical-group {
    display: grid;
    gap: 12px;
  }

  .horizontal-group {
    display: flex;
    align-items: center;
    > *:not(:first-child) {
      margin-left: 12px;
    }
  }

  .publication-metadata {
    color: map-get($grey, 'lighten-1');
  }
}
</style>
